import {Component} from "@angular/core";

@Component({
  selector: "lib-home-value-range-graph",
  standalone: true,
  templateUrl: "./home-value-range-graph.component.svg"
})
export class HomeValueRangeGraphComponent {}
